import { render, staticRenderFns } from "./estates-list-subscription.vue?vue&type=template&id=718c184a&scoped=true"
import script from "./estates-list-subscription.vue?vue&type=script&lang=js"
export * from "./estates-list-subscription.vue?vue&type=script&lang=js"
import style0 from "./estates-list-subscription.vue?vue&type=style&index=0&id=718c184a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718c184a",
  null
  
)

export default component.exports